import httpRequest from '../../../components/http-request';
import DeviceSizes from '../../../components/DeviceSizes';
import $ from 'cash-dom';

class QuestionInfoGetter {
	static getQuestionContent(questionsOwnerPageId, question, callback) {
		httpRequest.post(ajaxurl, {
			action: 'get-prequal-question',
			questionsOwnerPageId: questionsOwnerPageId,
			question: question,
			forMobile: window.innerWidth < DeviceSizes.MD ? 1 : 0,
			ppc_language: $('html').attr('lang'),
		}, function (error, html) {
			if (error) {
				callback(null);
			} else {
				callback(html);
			}
		});
	}

	static getShowPrequalifyModal(questionsOwnerPageId, question, callback) {
		httpRequest.post(ajaxurl, {
			action: 'show-prequal-question',
			questionsOwnerPageId: questionsOwnerPageId,
			question: question,
		}, function (error, response) {
			callback(error, response);
		}, 'json');
	}
}

export default QuestionInfoGetter;
